import DirectionalButton from "../../components/DirectionalButton";

function Services({ content }) {
  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="services-intro" data-wow="fade-right">
              <p className="eybrow services-eybrow">
                <img
                  className="star-icon"
                  src="/assets/images/star.png"
                  alt=""
                  aria-hidden="true"
                />
                {content.eyebrow}
              </p>
              <h2 className="heading">{content.title}</h2>
              <p className="services-description">{content.description}</p>
              <DirectionalButton href={content.ctaHref}>
                {content.ctaLabel} <i className="fa-solid fa-arrow-right" />
              </DirectionalButton>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="service-cards">
              {content.items.map((service, index) => (
                <article
                  className="service-card"
                  key={service.number}
                  style={{ zIndex: index + 1 }}
                  data-wow="fade-left"
                >
                  <div className="row align-items-center g-4">
                    <div className="col-md-6">
                      <span className="service-number">{service.number}</span>
                      <p className="title">{service.title}</p>
                      <p>{service.description}</p>
                    </div>
                    <div className="col-md-6">
                      <img src={service.image} alt={service.title} />
                    </div>
                  </div>
                  <span className="service-divider" aria-hidden="true" />
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
